export function HelpersHTMLWin (pEditor, pHelpers)
{
  const htmlWinName = 'nmEditorHtmlWin_' + ((new Date()).getTime()) + '_' + pEditor.editorId;
  
  let htmlWin;


  this.create = () =>
  {
    htmlWin = window.open(pEditor.blankPageURL, htmlWinName, 'left=' + (Math.round((window.screen.width - 700) / 2)) + ', top=' + (Math.round((window.screen.height - 500) / 2)) + ', width=700, height=500, status=no, toolbar=no, menubar=no, location=no, resizable=no, scrollbars=no');
    setTimeout(function() { openHtmlWindow(); }, 100);
  };


  function openHtmlWindow()
  {
    if (!pEditor.pThis.isObjValid || pEditor.pThis.isObjValid < 2)
    {
      return false;
    }

    var htmlWinDoc = htmlWin.document;

    if (htmlWin && htmlWinDoc && htmlWinDoc.body && htmlWinDoc.body.innerHTML && htmlWinDoc.body.innerHTML.match(/##WA###BlankHTMLPageForEditorContentNew###WA##/))
    {
      htmlWinDoc.body.style.margin = 0;
      htmlWinDoc.body.style.padding = 0;
      htmlWinDoc.body.style.border = 'none';
      htmlWinDoc.body.innerHTML = '<textarea id="idTA_' + htmlWinName + '" style="width: 100%; height: 450px; border: 1px solid #000000;">' + pEditor.iFrameDoc.body.innerHTML + '</textarea><div style="margin: 10px 15px 0px 15px; text-align: right;"><span style="font-weight: bold;">' + pEditor.pThis.getTextDataLength() + '</span>&nbsp;text&nbsp;chars&nbsp;in&nbsp;<span style="font-weight: bold;">' + pEditor.content.getHtmlDataLength() + '</span>&nbsp;HTML&nbsp;chars&nbsp;&nbsp;&nbsp;<input type="button" value="Save" style="cursor: pointer;" onclick="opener.BEditor.EditorsManager.getEditorById(\'' + pEditor.editorId + '\').applyEditingHTML(); window.close();">&nbsp;&nbsp;&nbsp;<input type="button" value="Cancel" style="cursor: pointer;" onclick="window.close();"></div>';
    }
    else
    {
      setTimeout(function() { openHtmlWindow(); }, 100);
    }
  }


  this.applyEditingHTML = function()
  {
    pEditor.html.editor.setHTML(htmlWin.document.getElementById('idTA_' + htmlWinName).value);
  };
}